export const HypothesisStatuses = {
  Proven: "proven",
  Likely: "likely",
  Possible: "possible",
  Unlikely: "unlikely",
  Improbable: "improbable",
  Disproven: "disproven"
};
